import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { customFetcher } from '../useFetch';

/**
 * Admin-Endpoints für ProcessManagerType — Sperrzeiten + Cooldown im
 * DevHub bearbeitbar. Standardmäßig sind die Stammdaten via Module-JSON
 * read-only; diese Routen umgehen das bewusst und schreiben gezielte
 * Felder.
 */

export interface IPmTypeAdminRow {
  idProcessManagerType: number;
  ProcessManagerType: string;
  isAutomated: 0 | 1;
  isInstant: 0 | 1;
  isVisible: 0 | 1;
  CooldownInHours: number | null;
  ActiveFromHour: number | null;
  ActiveUntilHour: number | null;
  MaxTries: number | null;
}

export interface IPmTypeAdminUpdate {
  ActiveFromHour?: number | null;
  ActiveUntilHour?: number | null;
  CooldownInHours?: number;
  MaxTries?: number | null;
  isInstant?: boolean;
}

const QK_LIST = ['pmAdmin', 'types'];

export const useAdminPmTypeList = () => {
  const { data, isFetching, refetch } = useQuery<IPmTypeAdminRow[]>({
    refetchOnWindowFocus: false,
    queryKey: QK_LIST,
    queryFn: () =>
      customFetcher({
        endpoint: '/admin/processmanagertype/list',
      }) as Promise<IPmTypeAdminRow[]>,
  });
  return {
    pmTypes: Array.isArray(data) ? data : [],
    isFetchingPmTypes: isFetching,
    refetchPmTypes: refetch,
  };
};

export const useAdminPmTypeUpdate = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation<
    { updated: number; after: IPmTypeAdminRow },
    Error,
    { id: number; body: IPmTypeAdminUpdate }
  >({
    mutationFn: ({ id, body }) =>
      customFetcher({
        endpoint: `/admin/processmanagertype/${id}`,
        method: 'PUT',
        body,
      }) as Promise<{ updated: number; after: IPmTypeAdminRow }>,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: QK_LIST });
    },
  });
  return {
    updatePmType: mutateAsync,
    isUpdatingPmType: isPending,
  };
};
